module.exports = __webpack_public_path__ + "img/pr-7.2e23f9ca.png";